// Mock data for Januzzi & Alves Landing Page

export const siteConfig = {
  name: "Januzzi & Alves",
  tagline: "Advogados Associados",
  whatsappNumber: "5531983148709",
  whatsappMessage: "Olá, gostaria de falar sobre conflito societário",
  ctaText: "Falar com um advogado agora",
  address: "Avenida Prudente de Morais, 287, sala 1.607, Cidade Jardim, Belo Horizonte-MG",
  phones: [
    { name: "Escritório", number: "+55 (31) 9 8314-8709" }
  ]
};

export const heroData = {
  badge: "Advocacia empresarial em todo o Brasil.",
  headline: "Dissolução de sociedade e acordo de sócios para empresas.",
  subheadline: "Solução estratégica para conflitos ou prevenção. Advocacia que entende de negócios."
};

export const situacoesProblemas = [
  "Sócio não presta contas ou esconde números",
  "Retiradas irregulares de dinheiro",
  "Exclusão informal da gestão",
  "Bloqueio de acesso a contas ou documentos",
  "Empresa paralisada por brigas internas",
  "Sócio quer sair e não sabe quanto tem a receber",
  "Tentativas frustradas de acordo",
  "Suspeita de fraude ou má administração"
];

export const situacoesSolucoes = [
  "Dissolução parcial da sociedade",
  "Apuração de haveres",
  "Estruturação da saída do sócio",
  "Pedido judicial de exclusão",
  "Medidas urgentes para proteção patrimonial",
  "Negociação estratégica para acordo",
  "Condução completa do conflito societário"
];

export const conflitosText = {
  title: "Conflitos societários não se resolvem sozinhos.",
  paragraphs: [
    "Quando há briga entre sócios, a demora quase sempre favorece quem está em vantagem.",
    "O caminho é agir com estratégia jurídica, documentação correta e medidas firmes — antes que a situação fique irreversível."
  ],
  cta: "Entenda seus direitos agora."
};

export const cenarios = {
  title: "Dois cenários comuns quando existe\nconflito societário",
  cenario1: {
    title: "Cenário 1 — O problema vai sendo empurrado",
    intro: "Você tenta conversar, pede números, cobra explicações, mas nada muda.",
    items: [
      "O sócio continua tomando decisões sozinho.",
      "A empresa trava.",
      "O caixa fica nebuloso.",
      "O prejuízo cresce."
    ],
    conclusion: "Cada mês sem agir aumenta o risco."
  },
  cenario2: {
    title: "Cenário 2 — Você assume o controle jurídico",
    intro: "Você descobre a melhor situação a partir de agora e com isso:",
    items: [
      "Você entende sua posição legal.",
      "Sabe quanto pode receber.",
      "Bloqueia abusos.",
      "Estrutura a saída ou força uma solução."
    ],
    conclusion: "O conflito deixa de ser emocional e passa a ser estratégico."
  }
};

export const comoFunciona = {
  title: "Como funciona nosso trabalho",
  steps: [
    {
      number: "01",
      title: "Diagnóstico do conflito",
      description: "Entendemos sua situação, documentos, riscos e urgência."
    },
    {
      number: "02",
      title: "Estratégia jurídica",
      description: "Definimos o melhor caminho: acordo, medidas urgentes ou ação judicial."
    },
    {
      number: "03",
      title: "Execução e acompanhamento",
      description: "Você recebe orientação clara, atualizações e condução ativa até o desfecho."
    }
  ],
  cta: "Comece agora pelo diagnóstico."
};

export const paraQuem = {
  title: "Para quem é essa página",
  subtitle: "Essa atuação é indicada para você que:",
  items: [
    "é sócio ou ex-sócio e quer sair com segurança",
    "precisa proteger seu patrimônio",
    "está sofrendo prejuízos com a má gestão",
    "quer clareza jurídica e próximos passos",
    "busca um escritório que trate seu caso como prioridade",
    "precisa resolver rápido antes que o problema escale"
  ],
  cta: "Veja se podemos te ajudar."
};

export const ctaFinal = {
  title: "O conflito já começou,\nou está prestes a começar?",
  subtitle: "Quanto antes você entende sua posição jurídica, maiores são as chances de proteger patrimônio, empresa e tranquilidade."
};

export const faqData = [
  {
    question: "O que é apuração de haveres?",
    answer: "É o procedimento para calcular quanto você tem direito a receber ao sair da sociedade, conforme critérios legais e contábeis."
  },
  {
    question: "Isso costuma ser rápido?",
    answer: "Depende da postura da outra parte e da complexidade do caso. O foco é escolher o caminho mais eficiente e impedir que o prejuízo continue aumentando."
  },
  {
    question: "Dá para resolver sem processo?",
    answer: "Em alguns casos, sim. Quando há margem, um acordo bem estruturado pode encurtar tempo e custo. Quando não, atuamos de forma firme para proteger seus direitos."
  }
];
